import { EnumLegalEntityRole } from "../../buildings-shared/model/legal-entity-basic-info";
import { SharedUtils } from "../../buildings-shared/utilities/shared-utils";

export class UserLegalEntityInfo {
    id: number | undefined;
    userId: number | undefined;
    legalEntityId: number | undefined;
    statusId: number | undefined;
    legalEntityRole: EnumLegalEntityRole | undefined;
    userLegalEntityRoles: EnumUserLegalEntityRole[] | undefined;
    userLegalEntityRolesNew: EnumUserLegalEntityRole[] | undefined;
    userLegalEntityProfile: EnumUserLegalEntityProfile | undefined;
    userLegalEntityProfileNew: EnumUserLegalEntityProfile | undefined;
    active: boolean | undefined;
    delegate: boolean | undefined;

    public getUserLegalEntityRolesKeyString(): string {
        let userLegalEntityRoles: string = "";
        if (SharedUtils.inputValueIsPresent(this.userLegalEntityRoles)) {
            this.userLegalEntityRoles!.forEach( (role: EnumUserLegalEntityRole) => {
                if (userLegalEntityRoles === "") {
                    userLegalEntityRoles = role.toString() === "NONE" ? userLegalEntityRoles : userLegalEntityRoles.concat(role.toString());
                } else {
                    userLegalEntityRoles = role.toString() === "NONE" ? userLegalEntityRoles : userLegalEntityRoles.concat(", " + role.toString());
                }
            });
        }
        return userLegalEntityRoles;
    }

    public getUserLegalEntityRolesValueString(): string {
        let userLegalEntityRoles: string = "";
        if (SharedUtils.inputValueIsPresent(this.userLegalEntityRoles)) {
            this.userLegalEntityRoles!.forEach( (role: EnumUserLegalEntityRole) => {
                if (userLegalEntityRoles === "") {
                    userLegalEntityRoles = role.toString() === "NONE" ? userLegalEntityRoles : userLegalEntityRoles.concat(SharedUtils.getEnumValue(EnumUserLegalEntityRole, role) as string);
                } else {
                    userLegalEntityRoles = role.toString() === "NONE" ? userLegalEntityRoles : userLegalEntityRoles.concat(", " + SharedUtils.getEnumValue(EnumUserLegalEntityRole, role) as string);
                }
            });
        }
        return userLegalEntityRoles;
    }

    public getUserLegalEntityRolesNewKeyString(): string {
        let userLegalEntityRoles: string = "";
        if (SharedUtils.inputValueIsPresent(this.userLegalEntityRolesNew)) {
            this.userLegalEntityRolesNew!.forEach( (role: EnumUserLegalEntityRole) => {
                if (userLegalEntityRoles === "") {
                    userLegalEntityRoles = role.toString() === "NONE" ? userLegalEntityRoles : userLegalEntityRoles.concat(role.toString());
                } else {
                    userLegalEntityRoles = role.toString() === "NONE" ? userLegalEntityRoles : userLegalEntityRoles.concat(", " + role.toString());
                }
            });
        }
        return userLegalEntityRoles;
    }

    getUserLegalEntityRolesNewValueString(): string {
        let userLegalEntityRoles: string = "";
        if (SharedUtils.inputValueIsPresent(this.userLegalEntityRolesNew)) {
            this.userLegalEntityRolesNew!.forEach( (role: EnumUserLegalEntityRole) => {
                if (userLegalEntityRoles === "") {
                    userLegalEntityRoles = role.toString() === "NONE" ? userLegalEntityRoles : userLegalEntityRoles.concat(SharedUtils.getEnumValue(EnumUserLegalEntityRole, role) as string);
                } else {
                    userLegalEntityRoles = role.toString() === "NONE" ? userLegalEntityRoles : userLegalEntityRoles.concat(", " + SharedUtils.getEnumValue(EnumUserLegalEntityRole, role) as string);
                }
            });
        }
        return userLegalEntityRoles;
    }

    getUserLegalEntityProfileKeyString(): string {
        return this.userLegalEntityProfile?.toString() ?? '';
    }

    getUserLegalEntityProfileValueString(): string {
        return SharedUtils.getEnumValue(EnumUserLegalEntityProfile, this.userLegalEntityProfile ?? '') as string;
    }

    getUserLegalEntityProfileNewKeyString(): string {
        return this.userLegalEntityProfileNew?.toString() ?? '';
    }

    getUserLegalEntityProfileNewValueString(): string {
        return SharedUtils.getEnumValue(EnumUserLegalEntityProfile, this.userLegalEntityProfileNew ?? '') as string;
    }

    getUserLegalEntityStatusValueString(): string {
        return EnumUserLegalEntityStatus[this.statusId ?? 0] ?? '';
    }

    public static parseUserLegalEntityInfo(stringifiedUserLegalEntity: UserLegalEntityInfo): UserLegalEntityInfo | undefined {
        if (SharedUtils.inputValueIsEmpty(stringifiedUserLegalEntity) || SharedUtils.inputValueIsEmpty(stringifiedUserLegalEntity.id)) {
            return undefined;
        }
        const newUserLegalEntity = new UserLegalEntityInfo();

        if(stringifiedUserLegalEntity.id) newUserLegalEntity.id = stringifiedUserLegalEntity.id;
        if(stringifiedUserLegalEntity.userId) newUserLegalEntity.userId = stringifiedUserLegalEntity.userId;
        if(stringifiedUserLegalEntity.legalEntityId) newUserLegalEntity.legalEntityId = stringifiedUserLegalEntity.legalEntityId;
        if(stringifiedUserLegalEntity.statusId) newUserLegalEntity.statusId = stringifiedUserLegalEntity.statusId;
        if(stringifiedUserLegalEntity.legalEntityRole) newUserLegalEntity.legalEntityRole = stringifiedUserLegalEntity.legalEntityRole;
        newUserLegalEntity.userLegalEntityRoles = new Array<EnumUserLegalEntityRole>();
        if (stringifiedUserLegalEntity.userLegalEntityRoles && stringifiedUserLegalEntity.userLegalEntityRoles.length > 0) {
            let counter: number = stringifiedUserLegalEntity.userLegalEntityRoles.length;
            for (let i: number = 0; i < counter; i++) {
                newUserLegalEntity.userLegalEntityRoles.push(stringifiedUserLegalEntity.userLegalEntityRoles[i]);
            }
        } else {
            throw new Error("UserLegalEntityInfo.parseUserLegalEntityInfo() - ERROR - userLegalEntityRoles not found.  UserLegalEntityInfo.userLegalEntityRoles: " + stringifiedUserLegalEntity.userLegalEntityRoles);
        }
        if(stringifiedUserLegalEntity.userLegalEntityRolesNew) newUserLegalEntity.userLegalEntityRolesNew = stringifiedUserLegalEntity.userLegalEntityRolesNew;
        if(stringifiedUserLegalEntity.userLegalEntityProfile) newUserLegalEntity.userLegalEntityProfile = stringifiedUserLegalEntity.userLegalEntityProfile;
        if(stringifiedUserLegalEntity.userLegalEntityProfileNew) newUserLegalEntity.userLegalEntityProfileNew = stringifiedUserLegalEntity.userLegalEntityProfileNew;
        if(stringifiedUserLegalEntity.active) newUserLegalEntity.active = stringifiedUserLegalEntity.active;
        if(stringifiedUserLegalEntity.delegate) newUserLegalEntity.delegate = stringifiedUserLegalEntity.delegate;

        return newUserLegalEntity;
    }

    public static getEnumUserLegalEntityProfileList(): EnumUserLegalEntityProfile[] {
        return [EnumUserLegalEntityProfile.ADMINISTRATOR, EnumUserLegalEntityProfile.ASSOCIATE, EnumUserLegalEntityProfile.CHIEF_EXECUTIVE_OFFICER,
          EnumUserLegalEntityProfile.CONSULTANT, EnumUserLegalEntityProfile.COUNCILOR, EnumUserLegalEntityProfile.COWORKER,
          EnumUserLegalEntityProfile.EMPLOYEE, EnumUserLegalEntityProfile.EXECUTIVE, EnumUserLegalEntityProfile.MANAGER,
          EnumUserLegalEntityProfile.MANAGING_DIRECTOR, EnumUserLegalEntityProfile.OWNER, EnumUserLegalEntityProfile.PRESIDENT,
          EnumUserLegalEntityProfile.PROCURER, EnumUserLegalEntityProfile.SHAREHOLDER, EnumUserLegalEntityProfile.VICE_PRESIDENT];
    }

    public static getEnumUserLegalEntityRoleList(): EnumUserLegalEntityRole[] {
        return [EnumUserLegalEntityRole.ADMINISTRATOR, EnumUserLegalEntityRole.DOSSIER_MANAGER, EnumUserLegalEntityRole.USER_MANAGER];
    }
}

export enum EnumUserLegalEntityRole {
    NONE = 'none',
    ANY = 'any',
    ADMINISTRATOR = 'amministratore',
    DOSSIER_MANAGER = 'gestore pratiche',
    USER_MANAGER = 'gestore utenze',
    DOSSIER_DISPATCHER = 'assegnazione pratiche'
}

export enum EnumUserLegalEntityProfile {
    ADMINISTRATOR = 'amministratore',
    ASSOCIATE = 'associato',
    CHIEF_EXECUTIVE_OFFICER = 'direttore generale',
    CONSULTANT = 'consulente',
    COUNCILOR = 'consigliere',
    COWORKER = 'collaboratore',
    EMPLOYEE = 'dipendente',
    EXECUTIVE = 'esecutivo',
    MANAGER = 'manager',
    MANAGING_DIRECTOR = 'managing director',
    OWNER = 'proprietario',
    PRESIDENT = 'presidente',
    PROCURER = 'procuratore',
    SHAREHOLDER = 'azionista',
    VICE_PRESIDENT = 'vice presidente'
}

export enum EnumUserLegalEntityStatus {
    approval = 26,
    active = 27,
    refused = 28,
    inactive = 29,
    suspended = 30,
    banned = 31,
    erased = 32,
    closed = 33
}